import { AuthSession } from '../domain/entities/AuthSession';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/SessionManagementService';
import { AUTHENTICATION_SOURCES, TOKEN_TYPE } from '../constants/constants';

export interface IAuthSession {
    token: string;
    expiration: number;
    source?: string;
    email?: string;
}

export class UpdateAuthSessionUseCase {
    private authSession: AuthSession;
    private careAuthSession: AuthSession;
    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    constructor(private data: IAuthSession) {
        this.authSession = diContainer.get(serviceNames.authSession);
        this.careAuthSession = diContainer.get(serviceNames.careAuthSession);
    }

    public execute = () => {
        const authSession = new AuthSession(
            this.data.token,
            TOKEN_TYPE.USER,
            this.data.expiration,
            null
        );

        const targetAuthSession =
            this.data.source === AUTHENTICATION_SOURCES.CARE
                ? this.careAuthSession
                : this.authSession;

        targetAuthSession.updateAuthSession(authSession);
        targetAuthSession.setAuthSourceData(this.data);
    };
}
